import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { ClientResolverService } from '@app/core/client-resolver.service';
import { ClientService } from '@app/core/client.service';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare function initFeedbackWidget(containerId: string, clientId: string): void;
@Component({
  selector: 'app-feedback-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntegrationComponent implements OnInit, AfterViewInit {
  activeClient: any = {
    id: null
  };
  expandedPanel: string;
  feedbackSettingsForm!: FormGroup;
  feedbackSettingUrl: string = '';
  private ngUnsubscribe: Subject<any> = new Subject();

  constructor(
    private fb: FormBuilder,
    public clientResolver: ClientResolverService,
    private clientService: ClientService,
    private authService: AuthenticationService
  ) {
    this.activeClient = this.clientResolver.client;
  }

  ngOnInit(): void {
    this.getFeedbackSettings();
    this.feedbackSettingsForm = this.fb.group({
      openFeedback: [false]
    });
    this.feedbackSettingsForm.get('openFeedback').valueChanges.subscribe(() => {
      this.saveReservationBookSettings();
    });
  }

  ngAfterViewInit(): void {
    this.loadFeedbackContainerScript();
  }

  expandPanel(panel: string) {
    this.expandedPanel = panel;
  }

  loadFeedbackContainerScript() {
    const script = document.createElement('script');
    script.src = 'https://widgets.gastro.digital/assets/js/feedback.js';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      initFeedbackWidget('gd-feedback-container', this.activeClient.id);
    };
    document.body.appendChild(script);
  }

  getFeedbackSettings() {
    this.clientService
      .getFeedbackSettings()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        const { openFeedback = false } = res;
        if (openFeedback) {
          this.setFeedbackUrl();
        }
        this.feedbackSettingsForm.patchValue({ openFeedback: openFeedback }, { emitEvent: false });
      });
  }

  saveReservationBookSettings() {
    const payload = this.feedbackSettingsForm.getRawValue();
    console.log('API CALL ⇒ ', payload);
    this.clientService
      .saveFeedbackSettings(payload)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        response => {
          if (payload.openFeedback) {
            this.setFeedbackUrl();
          }
          console.log('Settings saved:', response);
        },
        error => {
          console.error('Error saving settings:', error);
        }
      );
  }

  setFeedbackUrl() {
    this.authService
      .getActiveClient()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        (clientData: any) => {
          this.feedbackSettingUrl = `${environment.feedbackBaseUrl}feedback/client/${clientData.id}`;
        },
        error => {
          this.feedbackSettingUrl = '';
          console.error('Error saving settings:', error);
        }
      );
  }
}
